import { Injectable, Inject } from '@angular/core';
import { Actions, createEffect, ofType, OnInitEffects } from '@ngrx/effects';
import { switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import {
    initHistoryTicketSearchFilter,
    resetTicketHistorySearchFilter,
    updateTicketHistorySearchFilter
} from './ticket-history.actions';
import { TicketHistoryFilterState } from '../ticket-history.model';
import Env from '@ridango/core/env';
import { Temporal } from '@js-temporal/polyfill';
import { Action } from '@ngrx/store';

@Injectable()
export class TicketHistoryEffects implements OnInitEffects {
    constructor(
        private actions$: Actions,
        @Inject('ENV') private env: Env
    ) {}

    initializeFilterState$: Observable<Action> = createEffect(() =>
        this.actions$.pipe(
            ofType(initHistoryTicketSearchFilter, resetTicketHistorySearchFilter),
            switchMap(() => {
                const todayDate = Temporal.Now.plainDateISO();
                const fromDate = this.env.HISTORY_TICKET_SEARCH_START_DATE_MONTHS_AGO
                    ? todayDate.subtract({ months: this.env.HISTORY_TICKET_SEARCH_START_DATE_MONTHS_AGO }).toString()
                    : todayDate.subtract({ months: this.env.IS_NEW_AFC ? 3 : 1 }).toString();

                const filterState: TicketHistoryFilterState = {
                    fromDate,
                    toDate: todayDate.toString(),
                    todayDate: todayDate.toString()
                };

                return of(updateTicketHistorySearchFilter({ payload: filterState }));
            })
        )
    );

    ngrxOnInitEffects(): Action {
        return initHistoryTicketSearchFilter();
    }
}
